import { RootState } from "@/redux/store";
import { useSelector } from "react-redux";

export function useCurrentUser() {
	return useSelector((state: RootState) => state.user.user);
}
